import React, { useContext } from 'react';
import Modal, { ModalTransition } from '@atlaskit/modal-dialog';

import ConfigureReportGadget from '../ConfigureReportGadget';
import DateInputContext from '../../contexts/DateInputContext';

const ConfigureReportGadgetModal = ({
  isOpen,
  close,
  editingGadget,
  onSaved,
}: {
  isOpen: boolean;
  close: () => void;
  editingGadget?: ReportGadgets.ReportGadget;
  onSaved: (gadget: ReportGadgets.ReportGadget) => void;
}) => {
  const parentDateContext = useContext(DateInputContext);

  return (
    <ModalTransition>
      {isOpen && (
        <Modal
          width={'95vw'}
          height={'80vh'}
          onClose={close}
          shouldScrollInViewport={false}
          autoFocus={false}
        >
          <ConfigureReportGadget
            editingGadget={editingGadget}
            close={close}
            onSaved={onSaved}
            parentDateRange={parentDateContext.dateRange}
            parentRelativeDateRange={parentDateContext.relativeDateRange}
            parentAdvancedRelativeDateRange={
              parentDateContext.advancedRelativeDateRange
            }
            parentDateField={parentDateContext.dateField}
          />
        </Modal>
      )}
    </ModalTransition>
  );
};

export default ConfigureReportGadgetModal;
